<div class="container mt-5">
  <div class="row justify-content-center">
    <div  >
      <div class="card text-center">
        <div class="card-header">
          <h2>Плащането беше отказано!</h2>
        </div>
        <div class="card-body">
          <p class="card-text">Вашето плащане беше отказано.</p>
          <p class="card-text">Моля, опитайте отново или се свържете с нас за повече информация.</p> 
        </div>
        <div class="card-footer text-muted">
          Благодарим ви, че използвате нашите услуги!
        </div>
      </div>
    </div>
  </div>
</div>
